// extracted by mini-css-extract-plugin
export var customList = "styles-module--custom-list--5f135";
export var list = "styles-module--list--6732e";
export var ordered = "styles-module--ordered--0e372";